import React from "react";

import { LookupActionsButton } from "../../../../../common/components/lookup-buttons/LookupActionsButton";
import { useAssociateLookupCloudAsset } from "./lookup-cloud-asset/useAssociateLookupCloudAsset";
import { useAssociateLookupContent } from "./lookup-content/useAssociateLookupContent";
import { useAssociateLookupHistory } from "./lookup-history/useAssociateLookupHistory";

export const AssociateLookupActionsButton = (): JSX.Element => {
    const { setContentFromLookupContent } = useAssociateLookupContent();
    const { setContentFromLookupHistory } = useAssociateLookupHistory();
    const { setContentFromLookupCloudAsset } = useAssociateLookupCloudAsset();

    return (
        <LookupActionsButton
            setContentFromLookupContent={setContentFromLookupContent}
            setContentFromLookupHistory={setContentFromLookupHistory}
            setContentFromLookupCloudAsset={setContentFromLookupCloudAsset}
        />
    );
};
